export const stringToLocaleDateTimeString = (val) => {
  if (!val) {
    return;
  }

  return new Date(val).toLocaleString();
}